/**
 * @author Madhu.Sudhan
 * @Date: 2023-05-20 13:05:06
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-05-20 17:50:20
 */

import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Card, Row, Col, Form, Breadcrumb, Table, Divider, Tabs, DatePicker, Button, Modal, Icon } from 'antd';

import { Link } from 'react-router-dom';
import { AppWrappperHOC } from '../Root/HOC';
import { constants, utils } from '../../devUtils';
import Container from '../../components/Container';
import { StyledAntTable, ZaggleCard } from '../NetworkCards/StyledNetworkCard';
import { DEFAULT_PRE_TRANS_PAYLOAD, updateObjectKeyValues, HeaderTable } from '../NetworkCards/constants';
import { INFO_MESSAGES, startDate, startDate2, today } from './constants';
import StyledSuccessMessage from './SuccessMessage';
import { IndusIndRequestStatementPropTypes, IndusIndRequestStatementmapDispatchToProps, IndusIndRequestStatementmapStateToProps } from './IndusIndRequestStatementDatahandler';

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

class IndusIndRequestStatement extends PureComponent {
  constructor(props) {
    super(props);
    const
      {
        match: {
          params:
        {
          id = '',
        } = {},
        } = {},
      } = props;
    this.state = {
      from_date: '',
      to_date: '',
      activeTabKey: '1',
      modalType: '',
    };
    this.statelesskeys = {
      defaultPayload: {},
      paramsId: id,
      setActiveTabKey: '1',
      current_page: 1,
    };
    this.handleSendReport = this.handleSendReport.bind(this);
    this.handleTabsChange = this.handleTabsChange.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
    this.handleGenerateStatement = this.handleGenerateStatement.bind(this);
    this.handlePaginationDataChange = this.handlePaginationDataChange.bind(this);
  }

  componentDidMount() {
    const {
      match:
      {
        params:
        {
          id = '',
        } = {},
      } = {},
      onfetchTransactions,
      onFetchCardDataYsc,
    } = this.props;
    onFetchCardDataYsc({ ysc_card_id: id });
    onfetchTransactions({ ysc_card_id: id }, { ...DEFAULT_PRE_TRANS_PAYLOAD });
  }

  componentWillReceiveProps(nextProps) {
    const {
      isIndusindStatementData: _isIndusindStatementData,
      onReportGenerate,
    } = this.props;
    const {
      isIndusindStatementData, isIndusindStatementData: { status, pdf },
    } = nextProps;
    if (!utils.isEqual(isIndusindStatementData, _isIndusindStatementData) && status && pdf) {
      this.setState({ modalType: 'DOWNLOAD_SUCCESS' });
      onReportGenerate({}, { pdf });
    }
  }

  getColumnHeader(CardDataYsc = {}, paramsId) {
    const {
      card_info: {
        MultipurposeCard = '',
      } = {} } = CardDataYsc;

    let _HeaderTable = HeaderTable;
    if (['Physical', 'Virtual'].includes(paramsId) && MultipurposeCard) {
      _HeaderTable = HeaderTable.filter(({ dataIndex }) => dataIndex !== 'wallet_name');
    }
    return _HeaderTable;
  }

  handlePaginationDataChange(page) {
    const {
      onfetchTransactions,
      match: {
        params: {
          id = '',
        } = {},
      } = {},
      onResetPopup,
    } = this.props;
    const { from_date, to_date } = this.state;
    const { setActiveTabKey } = this.statelesskeys;
    switch (setActiveTabKey) {
      case '1':
        onfetchTransactions({ ysc_card_id: id }, { from_date: startDate.format(constants.DATE_FORMAT_DDMMYYYY), to_date: today.format(constants.DATE_FORMAT_DDMMYYYY), count: 10, page_no: page });
        break;
      case '2':
        onfetchTransactions({ ysc_card_id: id }, { from_date: startDate2.format(constants.DATE_FORMAT_DDMMYYYY), to_date: today.format(constants.DATE_FORMAT_DDMMYYYY), count: 10, page_no: page });
        break;
      case '3':
        if (!to_date.length || !from_date.length) {
          onResetPopup(constants.ALERT_DATE_VALIDATION_REQUEST_STATEMENT, 'error');
        } else {
          onfetchTransactions({ ysc_card_id: id }, { from_date, to_date, count: 10, page_no: page });
        }
        break;
      default:
        onfetchTransactions({ ysc_card_id: id }, { page_no: page, count: 10 });
        break;
    }
  }

  handleRequestStatement(name, value, data) {
    switch (name) {
      case 'REQUEST_STATEMENT': {
        const [from, to] = data;
        this.setState({ from_date: from, to_date: to });
      }
        break;
      default:
        break;
    }
  }

  handleSendReport() {
    const { from_date, to_date } = this.state;
    const { setActiveTabKey } = this.statelesskeys;
    const {
      onReportGenerate,
      match:
      {
        params:
        {
          id = '',
        } = {},
      } = {},
    } = this.props;
    const payload = { from_date, to_date };
    switch (setActiveTabKey) {
      case '1':
        onReportGenerate({ ysc_card_id: id }, { from_date: startDate.format(constants.DATE_FORMAT_DDMMYYYY), to_date: today.format(constants.DATE_FORMAT_DDMMYYYY) });
        break;
      case '2':
        onReportGenerate({ ysc_card_id: id }, { from_date: startDate2.format(constants.DATE_FORMAT_DDMMYYYY), to_date: today.format(constants.DATE_FORMAT_DDMMYYYY) });
        break;
      case '3':
        onReportGenerate({ ysc_card_id: id }, payload);
        break;
      default:
        break;
    }
  }

  handleDownloadPdf() {
    const { from_date, to_date } = this.state;
    const { setActiveTabKey } = this.statelesskeys;
    const {
      onReportGenerate,
      match:
      {
        params:
        {
          id = '',
        } = {},
      } = {},
    } = this.props;
    switch (setActiveTabKey) {
      case '1':
        onReportGenerate({ ysc_card_id: id }, { download: 'Yes', from_date: startDate.format(constants.DATE_FORMAT_DDMMYYYY), to_date: today.format(constants.DATE_FORMAT_DDMMYYYY) });
        break;
      case '2':
        onReportGenerate({ ysc_card_id: id }, { download: 'Yes', from_date: startDate2.format(constants.DATE_FORMAT_DDMMYYYY), to_date: today.format(constants.DATE_FORMAT_DDMMYYYY) });
        break;
      case '3':
        onReportGenerate({ ysc_card_id: id }, { download: 'Yes', from_date, to_date });
        break;
      default:
        break;
    }
  }

  handleGenerateStatement() {
    const { from_date, to_date } = this.state;
    const { setActiveTabKey } = this.statelesskeys;
    const {
      onfetchTransactions,
      match:
      {
        params:
        {
          id = '',
        } = {},
      } = {},
      onResetPopup,
    } = this.props;
    switch (setActiveTabKey) {
      case '1':
        onfetchTransactions({ ysc_card_id: id }, { from_date: startDate.format(constants.DATE_FORMAT_DDMMYYYY), to_date: today.format(constants.DATE_FORMAT_DDMMYYYY), count: 10 });
        this.statelesskeys.current_page = 1;
        break;
      case '2':
        onfetchTransactions({ ysc_card_id: id }, { from_date: startDate2.format(constants.DATE_FORMAT_DDMMYYYY), to_date: today.format(constants.DATE_FORMAT_DDMMYYYY), count: 10 });
        this.statelesskeys.current_page = 1;
        break;
      case '3':
        if (!to_date.length || !from_date.length) {
          onResetPopup(constants.ALERT_DATE_VALIDATION_REQUEST_STATEMENT, 'error');
        } else {
          onfetchTransactions({ ysc_card_id: id }, { from_date, to_date, count: 10 });
        }
        this.statelesskeys.current_page = 1;
        break;
      default:
        break;
    }
  }

  handleTabsChange(key) {
    this.statelesskeys.setActiveTabKey = key;
    if (key === '3') {
      this.setState({ from_date: '', to_date: '' });
    }
  }

  handleModal(type) {
    this.setState({
      modalType: typeof (type) === 'string' ? type : '',
    });
  }

  downloadPdf() {
    const {
      isIndusindStatementData: {
        pdf = '',
      } = {},
    } = this.props;
    const globalWindow = utils.getWindowInstance();
    globalWindow.open(pdf);
  }

  renderModalUI(modalType) {
    const { DOWNLOAD_INFO, PASSWORD_INFO, PASSWORD_EXAMPLE } = INFO_MESSAGES;
    switch (modalType) {
      case 'DOWNLOAD_SUCCESS':
        return (
          <StyledSuccessMessage>
            <Row className="justify-content-center">
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                <Icon
                  type="info-circle"
                  className="icon-blue"
                  theme="filled"
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                <h2
                  className="font-20"
                >
                  <strong>
                    {DOWNLOAD_INFO}
                  </strong>
                </h2>
              </Col>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                  <Button
                    className="ant-btn green-btn width-8"
                    onClick={() => this.downloadPdf()}
                  > Download
                  </Button>
                </Col>
              </Row>
            </Row>
            <br />
            <Row
              className="custom-note"
            >
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-left">
                <h2 className="font-16">
                  <strong>Note:</strong>
                </h2>
                <h4 className="font-14">
                  {PASSWORD_INFO}
                </h4>
                <h3 className="note-info">
                  <strong>For Example: &nbsp;</strong>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-left">
                    <h4
                      className="font-14"
                    >
                      {PASSWORD_EXAMPLE}
                    </h4>
                  </Col>
                </h3>
              </Col>
            </Row>
          </StyledSuccessMessage>
        );
      default:
        return <div />;
    }
  }

  renderIndusIndRequestStatementHeader() {
    const { to_date, from_date, activeTabKey } = this.state;
    return (
      <Card className="rounded noborder noshadow">
        <Row align="top" type="flex" justify="center" gutter={20}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <h2>Request Statement</h2>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Divider className="margin-t-2" />
          </Col>
          <Col xs={24} sm={24} md={18} lg={18} xl={18}>
            <Tabs className="custom-tabs" type="card" onChange={(key) => this.handleTabsChange(key)} defaultActiveKey={activeTabKey}>
              <TabPane tab="1 Month" key="1">
                <Row align="top" type="flex" justify="center" gutter={20}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                    <RangePicker
                      className="custom-rangepicker"
                      format={constants.DATE_FORMAT_DDMMYYYY}
                      disabledDate={utils.disableDate}
                      defaultValue={[startDate, today]}
                      disabled
                    />
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="3 Months" key="2">
                <Row align="top" type="flex" justify="center" gutter={20}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                    <RangePicker
                      className="custom-rangepicker"
                      format={constants.DATE_FORMAT_DDMMYYYY}
                      disabledDate={utils.disableDate}
                      defaultValue={[startDate2, today]}
                      disabled
                    />
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="Custom" key="3">
                <Row align="top" type="flex" justify="center" gutter={20}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                    <RangePicker
                      className="custom-rangepicker"
                      format={constants.DATE_FORMAT_DDMMYYYY}
                      value={from_date ?
                        [utils.momentInstance(from_date, constants.DATE_FORMAT_DDMMYYYY),
                          utils.momentInstance(to_date, constants.DATE_FORMAT_DDMMYYYY)]
                        : ''}
                      onChange={(value, evt) => this.handleRequestStatement('REQUEST_STATEMENT', value, evt)}
                      disabledDate={utils.disableDate}
                    />
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
            <Row align="top" type="flex" justify="center" gutter={20}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                <Button
                  className="ant-btn green-btn margin-t-3 width-3"
                  onClick={() => this.handleGenerateStatement()}
                >
                  Show Filter Transactions
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    );
  }

  renderIndusIndRequestStatementButtons() {
    const {
      paramsId,
      current_page,
    } = this.statelesskeys;
    const {
      CardDataYsc = {},
      isLoadingStatus = false,
      transactionsData: {
        transactions = [],
        total_records = '',
      } = {},
    } = this.props;
    const transactionsDebitCreditModified = updateObjectKeyValues(transactions);
    return (
      <Card className="rounded noborder noshadow">
        <Row align="top" type="flex" gutter={30}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>Transaction History</h2>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-right">
            <Button
              className="margin-r-1 width-3"
              onClick={() => this.handleDownloadPdf()}
            >Download
            </Button>
            <Button
              className="ant-btn green-btn width-3"
              onClick={() => this.handleSendReport()}
            >Send Over Mail
            </Button>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <StyledAntTable>
              <Table
                className="pro-ant-table"
                size="large"
                rowKey="transaction_time"
                dataSource={transactionsDebitCreditModified}
                columns={this.getColumnHeader(CardDataYsc, paramsId)}
                loading={isLoadingStatus}
                pagination={{
                  total: total_records || 0,
                  current: current_page,
                  onChange: (page) => {
                    this.statelesskeys.current_page = page;
                    this.handlePaginationDataChange(page);
                  },
                }}
              />
            </StyledAntTable>
          </Col>
        </Row>
      </Card>
    );
  }

  render() {
    const {
      modalType,
    } = this.state;
    return (
      <div>
        <Modal
          visible={!!modalType}
          onCancel={this.handleModal}
          size="sm"
          classname="default-popup"
          title={null}
          maskClosable={false}
          footer={null}
          width="450px"
        >
          {modalType && this.renderModalUI(modalType)}
        </Modal>
        <br clear="all" />
        <Fragment>
          <Container>
            <ZaggleCard>
              <Row align="middle" type="flex" gutter={24} className="margin-t-2">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <h1>Manage Zaggle Cards</h1>
                  <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                    <Breadcrumb.Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>Request Statement</Breadcrumb.Item>
                  </Breadcrumb>
                </Col>
              </Row>
              {this.renderIndusIndRequestStatementHeader()}
              {this.renderIndusIndRequestStatementButtons()}
            </ZaggleCard>
          </Container>
        </Fragment>
      </div>
    );
  }
}

IndusIndRequestStatement.propTypes = IndusIndRequestStatementPropTypes;

const IndusIndRequestStatementWrapper = Form.create({ name: 'normal_admin' })(IndusIndRequestStatement);
export default connect(IndusIndRequestStatementmapStateToProps, IndusIndRequestStatementmapDispatchToProps)(AppWrappperHOC(IndusIndRequestStatementWrapper));
export { IndusIndRequestStatement, IndusIndRequestStatementmapStateToProps, IndusIndRequestStatementmapDispatchToProps, IndusIndRequestStatementWrapper };




// WEBPACK FOOTER //
// client/containers/IndusIndRequestStatement/index.js